import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackUserEditedParameters extends TrackEventBaseParameters<null, "has_approver" | "role"> {}

const trackUserEdited = (parameters: TrackUserEditedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "user_edited", ...parameters }, options);
};

export default trackUserEdited;
